@if (course()) {
	<nz-table
		#sectionTable
		[nzData]="sections()"
		[nzBordered]="true"
		[nzShowPagination]="true"
		[nzFrontPagination]="false"
		[nzPageIndex]="pageNumber()"
		[nzPageSize]="SECTIONS_PER_PAGE"
		[nzTotal]="totalSections()"
		(nzPageIndexChange)="onPageIndexChange($event)"
		nzSize="small"
		[nzLoading]="loading()"
	>
		<thead>
			<tr>
				<th
					nzWidth="40%"
					[nzSortFn]="sortNameFn"
					[nzSortOrder]="sortOrder()"
					(nzSortOrderChange)="onSortOrderChange($event)"
				>
					Name
				</th>
				<th nzWidth="20%">Language</th>
				<th nzWidth="20%">Location Name</th>
				<th nzWidth="20%">Code</th>
				<th nzWidth="20%"></th>
			</tr>
		</thead>
		<tbody>
			@for (section of sectionTable.data; track section) {
				<tr [class.selected]="editSection()?.uuid === section.uuid" class="section-row">
					<td>{{ section.name }}</td>
					<td>{{ section.language }}</td>
					<td>{{ section.location_uuid | locationName | async }}</td>
					<td>{{ section.section_code }}</td>
					<td>
						<button
							nz-button
							nzType="text"
							nzShape="circle"
							nzSize="small"
							(click)="edit(section); $event.preventDefault()"
							title="Edit"
						>
							<span nz-icon nzType="edit" nzTheme="outline"></span>
						</button>
						<button
							nz-button
							nzType="text"
							nzShape="circle"
							nzSize="small"
							nz-popconfirm
							nzPopconfirmTitle="Are you sure delete this?"
							nzPopconfirmPlacement="bottom"
							(nzOnConfirm)="delete(section)"
							title="Delete"
						>
							<span nz-icon nzType="delete" nzTheme="outline"></span>
						</button>
					</td>
				</tr>
			}
		</tbody>
	</nz-table>
} @else {
	<nz-empty nzNotFoundContent="No course selected" [nzNotFoundImage]="'simple'"></nz-empty>
}
